export const BATTERY_ALERT = 'BATTERY'
export const CLIMATE_ALERT = 'CLIMATE'
export const ROOTZONE_ALERT = 'ROOTZONE'
export const NO_DATA_ALERT = 'NO_DATA'
